import { CheckListFilter } from '@app/modules/table/classes/column-filters/check-list/check-list-filter.class';
import { ColumnFilterDisplay } from '@app/modules/table/types/column-filter-display.type';

export class RatingCheckListFilter extends CheckListFilter {
    type: ColumnFilterDisplay = 'ratingChecklist';
}
